/**
 * Socket 生命周期管理器
 * shell 嵌入模式下不在启动时初始化 socket,
 * 按路由按需管理:/chat 进入时连接,离开时断开。
 */
import { isShellEmbedded } from '@/libs/util';

type SocketState = 'idle' | 'connecting' | 'connected' | 'disconnecting';
let socketState: SocketState = 'idle';

const SOCKET_REQUIRED_ROUTE_PREFIXES: string[] = ['/chat'];

let socketV1Instance: any = null;
let socketV2Instance: any = null;

let _initSocketV1: ((opts?: any) => any) | null = null;
let _initSocketV2: ((opts?: any) => any) | null = null;
let _initOpts: any = null;

export function registerSocketInitializers(
    initV1: (o?: any) => any,
    initV2: (o?: any) => any,
    opts?: any,
) {
    _initSocketV1 = initV1;
    _initSocketV2 = initV2;
    _initOpts = opts;
}

export function routeNeedsSocket(path: string): boolean {
    return SOCKET_REQUIRED_ROUTE_PREFIXES.some((prefix) => path.startsWith(prefix));
}

export function ensureSocket(): void {
    if (socketState === 'connected' || socketState === 'connecting') return;
    if (!_initSocketV1 || !_initSocketV2) {
        console.warn('[socket-manager] initializers not registered');
        return;
    }
    socketState = 'connecting';
    console.log('[socket-manager] connecting...');
    try {
        socketV1Instance = _initSocketV1(_initOpts);
        socketV2Instance = _initSocketV2(_initOpts);
        socketState = 'connected';
        console.log('[socket-manager] connected');
    } catch (e) {
        socketState = 'idle';
        console.error('[socket-manager] init failed:', e);
    }
}

export function releaseSocketIfActive(): void {
    if (socketState === 'idle' || socketState === 'disconnecting') return;
    if (socketState === 'connecting') {
        console.log('[socket-manager] connect in progress, will disconnect after');
        setTimeout(() => releaseSocketIfActive(), 100);
        return;
    }
    socketState = 'disconnecting';
    console.log('[socket-manager] disconnecting...');
    try {
        socketV1Instance?.disconnect?.();
        socketV2Instance?.disconnect?.();
    } catch (e) {
        console.error('[socket-manager] disconnect error:', e);
    }
    socketV1Instance = null;
    socketV2Instance = null;
    socketState = 'idle';
    console.log('[socket-manager] disconnected');
}

export function getSocketV1(): any { return socketV1Instance; }
export function getSocketV2(): any { return socketV2Instance; }
export function isLazySocketMode(): boolean { return isShellEmbedded(); }
